import { useEffect, useState } from "react";
import { Star, Check, Trash2 } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { api } from "@/lib/api";

export const PendingReviews = () => {
  const { t } = useLang();
  const p = t.dash.pendingReviews;
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/testimonials/pending").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  const act = async (id, approve) => {
    if (approve) await api.post(`/testimonials/${id}/approve`);
    else await api.delete(`/testimonials/${id}`);
    setItems((xs) => xs.filter((x) => x.id !== id));
  };

  if (!items.length) return null;

  return (
    <div className="bg-[#111111] border border-[#FBBC04]/30 p-6 md:p-8 mb-10" data-testid="pending-reviews-panel">
      <p className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-white/40 mb-5">
        <Star className="w-4 h-4 text-[#FBBC04]" /> {p.title} ({items.length})
      </p>
      <div className="grid md:grid-cols-2 gap-4">
        {items.map((r) => (
          <div key={r.id} className="border border-white/10 bg-[#0a0a0a] p-4" data-testid={`pending-review-${r.id}`}>
            <p className="text-sm font-semibold">{r.name} · <span className="text-[#FBBC04]">{r.rating}/5</span></p>
            <p className="text-xs text-white/60 mt-1.5 leading-relaxed">“{r.text}”</p>
            {r.photo_path && (
              <img
                src={`${api.defaults.baseURL}/review-photos/${r.photo_path}`}
                alt={r.name}
                className="mt-2 rounded-sm border border-white/10 max-h-28 object-cover"
                data-testid={`pending-review-photo-${r.id}`}
              />
            )}
            {r.video_path && (
              <video
                controls
                preload="metadata"
                src={`${api.defaults.baseURL}/review-videos/${r.video_path}`}
                className="mt-2 rounded-sm border border-white/10 max-h-44 w-full bg-black"
                data-testid={`pending-review-video-${r.id}`}
              />
            )}
            <div className="flex gap-2 mt-3">
              <button
                onClick={() => act(r.id, true)}
                data-testid={`review-approve-${r.id}`}
                className="inline-flex items-center gap-1.5 text-[11px] font-semibold text-emerald-400 border border-emerald-500/30 hover:bg-emerald-500/10 px-3 py-1 rounded-full transition-colors duration-200"
              >
                <Check className="w-3 h-3" /> {p.approve}
              </button>
              <button
                onClick={() => act(r.id, false)}
                data-testid={`review-reject-${r.id}`}
                className="inline-flex items-center gap-1.5 text-[11px] font-semibold text-red-400 border border-red-500/30 hover:bg-red-500/10 px-3 py-1 rounded-full transition-colors duration-200"
              >
                <Trash2 className="w-3 h-3" /> {p.reject}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
